import * as Yup from 'yup'

export const applicationValidation = Yup.object().shape({
    application_name: Yup.string().required('Application name is required'),
    application_type: Yup.string().required('Application type is required'),
    application_description: Yup.string().required('A description is required'),
})